import React, { useContext, useEffect } from 'react';
import { Route,Routes,useNavigate } from 'react-router-dom'
import PanelLayout from './Panel';
import Login from './Login';
import { history } from './services/history';


// Components
import Dashboard from './components/Dashboard';

import Register from './components/BusinessGP/Register';

import OrganizationsIndex from './components/Organizations/Index';
import OrganizationsCreate from './components/Organizations/Create';
import OrganizationsWizard from './components/Organizations/Wizard';
import OrganizationsUpdate from './components/Organizations/Update';
import OrganizationsContracts from './components/Organizations/Contract';

import GuildsIndex from './components/Guilds/Index';
import GuildsCreate from './components/Guilds/Create';
import GuildsUpdate from './components/Guilds/Update';
import GuildsSubGuilds from './components/Guilds/SubGuilds';
import GuildsSubGuildsUpdate from './components/Guilds/UpdateSubGuild';

import HoldingIndex from './components/Holding/Index';
import HoldingCreate from './components/Holding/Create';
import HoldingUpdate from './components/Holding/Update';

import BranchesIndex from './components/Branches/Index';
import BranchesCreate from './components/Branches/Create';
import BranchesUpdate from './components/Branches/Update';

import TemplateIndex from './components/Template/Index';
import TemplateCreate from './components/Template/Create';
import TemplateUpdate from './components/Template/Update';

import GroupIndex from './components/Group/Index';
import GroupCreate from './components/Group/Create';
import GroupUpdate from './components/Group/Update';

import ServiceIndex from './components/Service/Index';
import ServiceCreate from './components/Service/Create';
import ServiceUpdate from './components/Service/Update';

import SubServiceIndex from './components/SubService/Index';
import SubServiceCreate from './components/SubService/Create';
import SubServiceUpdate from './components/SubService/Update';

import PersonnelIndex from './components/Personnel/Index';
import PersonnelCreate from './components/Personnel/Create';
import PersonnelUpdate from './components/Personnel/Update';

import SurveyIndex from './components/Survey/Index';
import SurveyCreate from './components/Survey/Create';
import SurveyUpdate from './components/Survey/Update';
import SurveySms from './components/Survey/Sms';

import SurveyQuestionIndex from './components/SurveyQuestion/Index';
import SurveyQuestionCreate from './components/SurveyQuestion/Create';
import SurveyQuestionUpdate from './components/SurveyQuestion/Update';

import SurveyPointsIndex from './components/SurveyPoints/Index';
import SurveyPointsCreate from './components/SurveyPoints/Create';
import SurveyPointsUpdate from './components/SurveyPoints/Update';

import SurveyCriteriasIndex from './components/SurveyCriterias/Index';
import SurveyCriteriasCreate from './components/SurveyCriterias/Create';
import SurveyCriteriasUpdate from './components/SurveyCriterias/Update';

import RolesIndex from './components/Roles/Index';
import RolesCreate from './components/Roles/Create';
import RolesUpdate from './components/Roles/Update';
import RolesPermissions from './components/Roles/Permissions';

import PersonnelTypesIndex from './components/PersonnelTypes/Index';
import PersonnelTypesCreate from './components/PersonnelTypes/Create';
import PersonnelTypesUpdate from './components/PersonnelTypes/Update';

import DiscountsIndex from './components/Discounts/Index';
import DiscountsCreate from './components/Discounts/Create';
import DiscountsUpdate from './components/Discounts/Update';

import DeliveriesIndex from './components/Deliveries/Index';
import DeliveriesCreate from './components/Deliveries/Create';
import DeliveriesUpdate from './components/Deliveries/Update';

import UsersIndex from './components/Users/Index';
import UsersCreate from './components/Users/Create';
import UsersUpdate from './components/Users/Update';
import UsersChangePassword from './components/Users/ChangePassword';

import ServiceConsumerIndex from './components/ServiceConsumer/Index';
import ServiceConsumerCreate from './components/ServiceConsumer/Create';
import ServiceConsumerView from './components/ServiceConsumer/View';
import ServiceConsumerUpdate from './components/ServiceConsumer/Update';

import NotificationsIndex from './components/Notifications/Index';
import NotificationsCreate from './components/Notifications/Create';
import NotificationsUpdate from './components/Notifications/Update';

import AdvertiseListIndex from './components/AdvertiseList/Index';
import AdvertiseListUpdate from './components/AdvertiseList/Update';


import Factor from './components/ServiceConsumer/Factor';

import ReportsIndex from './components/Reports/Index';

import BaseInfoIndex from './components/BaseInfo/Index';

import TransactionReversalIndex from './components/TransactionReversal/Index';

import TransactionListIndex from './components/TransactionList/Index';

import CommentsListIndex from './components/CommentsList/Index';

import OrdersListIndex from './components/OrdersList/Index';


import Poll from './Poll';
import ReportOpinion from './components/Reports/ReportOpinion';
import ReportHistory from './components/Reports/ReportHistory';
import ReportSMS from './components/Reports/ReportSMS';
import ReportSnappFood from './components/Reports/SnappFood';
import ReportSnappFoodTotal from './components/Reports/SnappFoodTotal';
import Settings from './components/Settings';
import ServicesManagment from './components/ServiceManagment/Index';

import ChildrenIndex from './components/Children/Index';
import ReIssueIndex from './components/ReissueList/Index';

import TicketIndex from './components/Tickets/Index';
import TicketShow from './components/Tickets/List/Show';
import TicketCreateCategory from './components/Tickets/Categories/Create';

import ReIssueRulesIndex from './components/ReIssue/Index';
import ReIssueRulesCreate from './components/ReIssue/Create';
import ReIssueRulesUpdate from './components/ReIssue/Update';

import HistoryIndex from './components/History/Index';
import DescriptionSegment from './components/BaseInfo/DescriptionSegment';
import FAQ from './components/BaseInfo/FAQ';
import Advertising from './components/AdvertiseList/Advertising';
import Pdf from './Pdf';
import BusinessQrList from './BusinessQrList';
import Index from './components/Lottery/Index';

import PendingListIndex from './components/PendingList/Index';

import PolicyPersonIndex from './components/PolicyPerson/Index'
import PolicyPersonInsert from './components/PolicyPerson/Insert'
import Transfer from './components/Transfer';

const App = () => {

  history.navigate = useNavigate()

  return (
    <Routes>
      <Route element={<PanelLayout />}>

        <Route path="/" element={<Dashboard />} />

        <Route path="organizations" element={<OrganizationsIndex />} />
        <Route path="organizations/create" element={<OrganizationsCreate />} />
        <Route path="organizations/wizard" element={<OrganizationsWizard />} />

        <Route path="register" element={<Register />} />

        <Route path="organizations/update/:id" element={<OrganizationsUpdate />} />
        <Route path="organizations/contracts/:id" element={<OrganizationsContracts />} />

        <Route path="guilds" element={<GuildsIndex />} />
        <Route path="guilds/create" element={<GuildsCreate />} />
        <Route path="guilds/update/:id" element={<GuildsUpdate />} />
        <Route path="guilds/sub-guilds/:id" element={<GuildsSubGuilds />} />
        <Route path="guilds/sub-guilds/update/:id" element={<GuildsSubGuildsUpdate />} />

        <Route path="holding" element={<HoldingIndex />} />
        <Route path="holding/create" element={<HoldingCreate />} />
        <Route path="holding/update/:id" element={<HoldingUpdate />} />

        <Route path="branches" element={<BranchesIndex />} />
        <Route path="branches/create" element={<BranchesCreate />} />
        <Route path="branches/update/:id" element={<BranchesUpdate />} />

        <Route path="template" element={<TemplateIndex />} />
        <Route path="template/create" element={<TemplateCreate />} />
        <Route path="template/update/:id" element={<TemplateUpdate />} />

        <Route path="service" element={<ServiceIndex />} />
        <Route path="service/create" element={<ServiceCreate />} />
        <Route path="service/update/:id" element={<ServiceUpdate />} />

        <Route path="subService" element={<SubServiceIndex />} />
        <Route path="subService/create" element={<SubServiceCreate />} />
        <Route path="subService/update/:id" element={<SubServiceUpdate />} />

        <Route path="group" element={<GroupIndex />} />
        <Route path="group/create" element={<GroupCreate />} />
        <Route path="group/update/:id" element={<GroupUpdate />} />

        <Route path="personnel" element={<PersonnelIndex />} />
        <Route path="personnel/create" element={<PersonnelCreate />} />
        <Route path="personnel/update/:id" element={<PersonnelUpdate />} />

        <Route path="survey" element={<SurveyIndex />} />
        <Route path="survey/create" element={<SurveyCreate />} />
        <Route path="survey/update/:id" element={<SurveyUpdate />} />
        <Route path="survey/sms" element={<SurveySms />} />

        <Route path="survey/surveyQuestion/:id" element={<SurveyQuestionIndex />} />
        <Route path="survey/surveyQuestion/create/:id" element={<SurveyQuestionCreate />} />
        <Route path="survey/surveyQuestion/:item/update/:id" element={<SurveyQuestionUpdate />} />

        <Route path="surveyCriterias" element={<SurveyCriteriasIndex />} />
        <Route path="surveyCriterias/create" element={<SurveyCriteriasCreate />} />
        <Route path="surveyCriterias/update/:id" element={<SurveyCriteriasUpdate />} />

        <Route path="surveyPoints" element={<SurveyPointsIndex />} />
        <Route path="surveyPoints/create" element={<SurveyPointsCreate />} />
        <Route path="surveyPoints/update/:id" element={<SurveyPointsUpdate />} />

        <Route path="roles" element={<RolesIndex />} />
        <Route path="roles/create" element={<RolesCreate />} />
        <Route path="roles/update/:id" element={<RolesUpdate />} />
        <Route path="roles/permissions/:id" element={<RolesPermissions />} />

        <Route path="personnel-types" element={<PersonnelTypesIndex />} />
        <Route path="personnel-types/create" element={<PersonnelTypesCreate />} />
        <Route path="personnel-types/update/:id" element={<PersonnelTypesUpdate />} />

        <Route path="discounts" element={<DiscountsIndex />} />
        <Route path="discounts/create" element={<DiscountsCreate />} />
        <Route path="discounts/update/:id" element={<DiscountsUpdate />} />

        <Route path="users" element={<UsersIndex />} />
        <Route path="users/create" element={<UsersCreate />} />
        <Route path="users/update/:id" element={<UsersUpdate />} />
        <Route path="users/change-password" element={<UsersChangePassword />} />

        <Route path="Deliveries" element={<DeliveriesIndex />} />
        <Route path="Deliveries/create" element={<DeliveriesCreate />} />
        <Route path="Deliveries/update/:id/:nationalNo" element={<DeliveriesUpdate />} />

        <Route path="service-consumer" element={<ServiceConsumerIndex />} />
        <Route path="service-consumer/create" element={<ServiceConsumerCreate />} />
        <Route path="service-consumer/view/:id" element={<ServiceConsumerView />} />
        <Route path="service-consumer/update/:id" element={<ServiceConsumerUpdate />} />

        <Route path="transaction-reversal" element={<TransactionReversalIndex />} />
        <Route path="transactionlist" element={<TransactionListIndex />} />
        <Route path="commentslist" element={<CommentsListIndex />} />
        <Route path="orderslist" element={<OrdersListIndex />} />


        <Route path="notifications" element={<NotificationsIndex />} />
        <Route path="notifications/create" element={<NotificationsCreate />} />
        <Route path="notifications/update/:id" element={<NotificationsUpdate />} />

        <Route path="advertiseList" element={<AdvertiseListIndex />} />
        <Route path="advertiseList/create" element={<Advertising />} />
        <Route path="advertiseList/update/:id" element={<AdvertiseListUpdate />} />

        <Route path="reports" element={<ReportsIndex />} />
        <Route path="reportsOpinion" element={<ReportOpinion />} />
        <Route path="reportsSMS" element={<ReportSMS />} />
        <Route path="reportsHistory" element={<ReportHistory />} />

        <Route path="policy-person" element={<PolicyPersonIndex />} />
        <Route path="policy-person/import" element={<PolicyPersonInsert />} />

        <Route path="reports/snappfood" element={<ReportSnappFood />} />
        <Route path="reports/snappfood-total" element={<ReportSnappFoodTotal />} />

        <Route path="baseInfo" element={<BaseInfoIndex />} />
        <Route path="baseInfo/segments" element={<DescriptionSegment />} />
        <Route path="baseInfo/faq" element={<FAQ />} />
        <Route path="settings" element={<Settings />} />

        <Route path="services-managment" element={<ServicesManagment />} />
        <Route path="children" element={<ChildrenIndex />} />
        <Route path="reissue-rules" element={<ReIssueRulesIndex />} />
        <Route path="reissue-rules/create" element={<ReIssueRulesCreate />} />
        <Route path="reissue-rules/update/:id" element={<ReIssueRulesUpdate />} />

        <Route path="tickets" element={<TicketIndex />} />
        <Route path="tickets/view/:id" element={<TicketShow />} />
        <Route path="tickets/categories/create" element={<TicketCreateCategory />} />

        <Route path="reissue" element={<ReIssueIndex />} />

        <Route path="history" element={<HistoryIndex />} />

        <Route path="lottery" element={<Index />} />

        <Route path="pending" element={<PendingListIndex />} />

        <Route path="transfer" element={<Transfer />} />

      </Route>

      <Route path="service-consumer/factor/:id" element={<Factor />} />
      <Route path="/poll/:token" exact element={<Poll />} />
      <Route path="/pdf" exact element={<Pdf />} />
      <Route path="/business-qr" exact element={<BusinessQrList />} />
      <Route path="/login" exact element={<Login />} />

    </Routes>
  );
}

export default App;